export enum ApplicationEnv {
  DEV = 'development',
  PROD = 'production',
  TEST = 'test',
}
